const key = "trip-ticket-section-order";

const applicable = resp => resp.config.method === "GET" && /api\/forms\/\d+$/.test(resp.config.url);

const modify = resp => {
	const form = resp.data.Data;
	const trip = form.Sections.find(section => section.Name === "Trip Details");
	const federal = form.Sections.find(section => section.Name === "Federal Fields");
	if(!trip || !federal) {
		return;
	}

	const detailFields = form.Fields.filter(field => field.IsDetail && !field.IsNegative);
	const detailSectionIds = new Set(detailFields.map(field => field.Section?.Id));
	const detailSections = form.Sections.filter(section => detailSectionIds.has(section.Id));
	const details = {
		Id: Math.min(0, ...form.Sections.map(section => section.Id)) - 1,
		Name: "Details",
		IsMulti: true,
		Order: 1,
		Sections: detailSections
	};

	trip.Order = 0;
	federal.Order = 2;
	detailSections.forEach(section => delete section.IsMulti);
	// Exercise field promotion from the nested section configuration.
	detailFields.forEach(field => delete field.IsDetail);
	form.Sections = [trip, details, federal, ...form.Sections.filter(section => section !== trip && section !== federal && !detailSectionIds.has(section.Id))];
};

export const tripTicketSectionOrder = [key, applicable, modify];
